const blankComponent = (props) => props.children;

export default blankComponent;



// WEBPACK FOOTER //
// ./src/components/BlankComponent/BlankComponent.js